{
  "search": "Hledat",
  "searchWithin": "Hledat v rámci"
}
